import { useEffect } from "react";
import { trackEmailClick, trackPhoneClick } from "@/lib/analytics";

type ContactLinkTrackingProps = {
  pathname: string;
};

/**
 * Tracks public contact-link engagement without collecting the visitor's own
 * phone number or email address. Delegated handling means newly added public
 * tel: and mailto: links inherit the same tracking automatically.
 */
export default function ContactLinkTracking({
  pathname,
}: ContactLinkTrackingProps) {
  useEffect(() => {
    const isPublicRoute =
      !pathname.startsWith("/admin") &&
      !pathname.startsWith("/client-os") &&
      !pathname.startsWith("/portal");

    if (!isPublicRoute) return;

    const handleClick = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const link = target.closest<HTMLAnchorElement>("a[href]");
      const href = link?.getAttribute("href")?.trim().toLowerCase() ?? "";
      if (!href) return;

      if (href.startsWith("tel:")) {
        trackPhoneClick({ location: pathname });
      }

      if (href.startsWith("mailto:")) {
        trackEmailClick({ location: pathname });
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [pathname]);

  return null;
}
